import { AngularMaterialModule } from './../../material.module';
import { SharedModule } from './../../shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegistrationRoutingModule } from './registration-routing.module';
import { DynamicControlsModule } from 'src/app/controls/dynamic-controls.module';
import { AddResumeSkillsComponent } from './components/add-resume-skills/add-resume-skills.component';
import { JobseekerRegistrationComponent } from './components/jobseeker-registration.component';
import { RegistrationOtpComponent } from './components/registration-otp/registration-otp.component';
import { WorkExperienceComponent } from './components/work-experience/work-experience.component';
import { DrivingLicenseComponent } from './components/driving-license/driving-license.component';
import { ResumeNomineeComponent } from './components/resume-nominee/resume-nominee.component';
import { EmergencyContactsComponent } from './components/emergency-contacts/emergency-contacts.component';
import { BankDetailsComponent } from './components/bank-details/bank-details.component';
import { LanguageListComponent } from './components/language-list/language-list.component';



@NgModule({
  declarations: [
    AddResumeSkillsComponent,
    JobseekerRegistrationComponent,
    RegistrationOtpComponent,
    WorkExperienceComponent,
    DrivingLicenseComponent,
    ResumeNomineeComponent,
    EmergencyContactsComponent,
    BankDetailsComponent,
    LanguageListComponent
  ],
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    DynamicControlsModule,
    SharedModule,
    AngularMaterialModule,
  ],
  exports: [JobseekerRegistrationComponent]
})
export class RegistrationModule { }  
